import { Link } from "react-router-dom";
import type { ItemMeta, NavigationAssignment } from "../types";
import { ArrowIcon } from "./Icons";

export function ItemCard({ item, assignment }: { item: ItemMeta; assignment?: NavigationAssignment }) {
  return <article className="item-card">
    <div className="item-meta"><span>第 {item.chapterNumber} 章 · {item.itemNumber}</span>{item.evidenceGradeExact && <span>原文证据等级 {item.evidenceGradeExact}</span>}</div>
    <h3><Link to={`/items/${item.id}`}>{item.titleExact}</Link></h3>
    {item.excerpt && <p>{item.excerpt}</p>}
    {assignment?.ageExpressions?.length ? <p className="condition-note">原文含年龄表达：{assignment.ageExpressions.map((a) => `${a.textExact}（${a.meaning === "study-population" ? "研究人群" : "语境待审"}）`).join("、")}。不得据此自动判断适用资格。</p> : <p className="condition-note">导航为编辑候选，尚待内容负责人复核；是否适用须以原文完整条件为准。</p>}
    <Link className="read-link" to={`/items/${item.id}`}>阅读完整原文 <ArrowIcon/></Link>
  </article>;
}
